export default __webpack_public_path__ + "static/media/American.cc30e824.jpg";